import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import cx from 'classnames'

import { IsDev } from '../../../helpers/build'
import LogoHeader from '../../icons/LogoHeader'
import MegaMenuItem from "./mainMenu/MegeMenuItem"
import {megaMenu} from "../helpers/drupalSettings"
import BurgerMenu from './burgerMenu/BurgerMenu'

class MegaMenuComponent extends Component {
  static propTypes = {
    menuDataLeft: PropTypes.object,
    menuDataRight: PropTypes.object,
    destinationsMenu: PropTypes.object,
    corporateMenu: PropTypes.object,
    setting: PropTypes.object,
    logoUrl: PropTypes.string,
    browser: PropTypes.objectOf(Object).isRequired,
    logoAlt: PropTypes.string,
    logoAriaLabel: PropTypes.string,
    backButtonLabel: PropTypes.string,
  }

  render() {
    const {
      menuDataLeft,
      menuDataRight,
      destinationsMenu,
      corporateMenu,
      logoUrl,
      browser,
      setting,
      logoAlt,
      logoAriaLabel,
      backButtonLabel,
    } = this.props

    const hideMenuItem = setting.hasOwnProperty('basket')

    const leftMenuItems = { destinationsKey: {...destinationsMenu}, ...menuDataLeft}

    return (
      <React.Fragment>
        {browser.greaterThan.extraLarge ? (
          <div className="megamenu-container">
            <div className="megamenu">
              <div className="megamenu__left">
                {Object.keys(leftMenuItems).map((key, index) => {
                    {return <MegaMenuItem
                      {...leftMenuItems[key]}
                      key={index}
                      index={index}
                      hideMenuItem={hideMenuItem}
                    />}
                  }
                )}
              </div>

              <div className="megamenu__item megamenu__item_logo-holder">
                <a className="site-logo" href={logoUrl} role="navigation" aria-label={logoAriaLabel}>
                  <LogoHeader alt={logoAlt} role="img"  aria-label={logoAriaLabel} className={cx('adagio-logo')}/>
                </a>
              </div>
              <div className="megamenu__right">
                {Object.keys(menuDataRight).map((key, index) => {
                    {return <MegaMenuItem
                      {...menuDataRight[key]}
                      classStyle="_right"
                      key={index}
                      index={index}
                      hideMenuItem={hideMenuItem}
                    />}
                  }
                )}
              </div>

            </div>
          </div>
        ) : (
          <React.Fragment>
            <BurgerMenu
              destinationsMenu={destinationsMenu}
              menuDataLeft={menuDataLeft}
              menuDataRight={menuDataRight}
              corporateMenu={corporateMenu}
              homeUrl={logoUrl}
              backButtonLabel={backButtonLabel}
            />

            <div className="megamenu__item megamenu__item_logo-holder">
              <a className={cx("site-logo")} href={logoUrl} aria-label="Adagio">
                <LogoHeader alt={logoAlt} role="img"  aria-label={logoAriaLabel} className={'adagio-logo'}/>
              </a>
            </div>

          </React.Fragment>
        )}
      </React.Fragment>
    )
  }
}


export default connect(
  ({
     main,
     browser,
   }) => ({
    menuDataLeft: IsDev ? megaMenu.leftMenu : main.setting.megaMenu.leftMenu,
    menuDataRight: IsDev ? megaMenu.rightMenu : main.setting.megaMenu.rightMenu,
    destinationsMenu: IsDev ? megaMenu.destinationsMenu : main.setting.megaMenu.destinationsMenu,
    corporateMenu: IsDev ? megaMenu.corporateMenu: main.setting.megaMenu.corporateMenu,
    logoUrl: IsDev ? megaMenu.logoUrl : main.setting.megaMenu.logoUrl,
    logoAlt: IsDev ? megaMenu.logoAlt : main.setting.megaMenu.logoAlt,
    logoAriaLabel: IsDev ? megaMenu.logoAriaLabel : main.setting.megaMenu.logoAriaLabel,
    browser,
    setting: main.setting,
    backButtonLabel:  IsDev ? megaMenu.backButtonLabel : main.setting.megaMenu.backButtonLabel,
  }),
)(MegaMenuComponent)
